/* ============================================================
   SA2 THEME — Scent + Art v2
   Scroll progress · Nav · Reveal · Mobile nav · Anchors
============================================================ */
(function () {
  'use strict';

  // ── Scroll progress bar ─────────────────────────────────
  const progressBar = document.getElementById('sa2-progress');
  function updateProgress() {
    if (!progressBar) return;
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    progressBar.style.width = (docHeight > 0 ? (scrollTop / docHeight) * 100 : 0) + '%';
  }

  // ── Nav scroll behaviour ────────────────────────────────
  const nav = document.getElementById('sa2-nav');
  function updateNav() {
    if (!nav) return;
    nav.classList.toggle('sa2-nav--scrolled', window.scrollY > 60);
  }

  // ── Combined scroll handler ─────────────────────────────
  window.addEventListener('scroll', function () {
    updateProgress();
    updateNav();
  }, { passive: true });
  updateNav();

  // ── Scroll reveal ───────────────────────────────────────
  const revealEls = document.querySelectorAll('.sa2-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sa2-visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  // ── Mobile nav ──────────────────────────────────────────
  const mobileToggle = document.getElementById('sa2-mobile-toggle');
  const mobileNav    = document.getElementById('sa2-mobile-nav');
  const mobileClose  = document.getElementById('sa2-mobile-close');

  function openMobileNav()  { if (mobileNav) mobileNav.classList.add('sa2-mobile-nav--open'); }
  function closeMobileNav() { if (mobileNav) mobileNav.classList.remove('sa2-mobile-nav--open'); }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  if (mobileClose)  mobileClose.addEventListener('click', closeMobileNav);

  // close on mobile link click
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav);
    });
  }

  // ── Smooth scroll for anchor links ─────────────────────
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const id = link.getAttribute('href');
      if (id.length < 2) return;
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        closeMobileNav();
      }
    });
  });

  // ── Newsletter forms (homepage + footer) ─────────────────
  // These are real Shopify {% form 'customer' %} forms — let the native POST
  // proceed. We only flag the submission so that, when Shopify redirects back
  // with ?customer_posted=true, the sitewide welcome banner (sa2-email-popup
  // snippet) reveals the WELCOME5 code. First-visit capture is the Klaviyo popup.
  ['sa2-nl-form', 'sa2-footer-nl'].forEach(function (id) {
    const form = document.getElementById(id);
    if (!form) return;
    form.addEventListener('submit', function () {
      const btn = form.querySelector('button[type="submit"], button');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      try { localStorage.setItem('sa2_popup_just_submitted', '1'); } catch (e) {}
      // no preventDefault — the form must actually submit
    });
  });

  // ── Custom select — editorial menu (desktop) + bottom sheet (mobile) ──
  // Progressive enhancement. Native <select> stays in the DOM (visually
  // hidden) so it still submits and works with no JS. Selecting dispatches a
  // native `change`, so collection-sort submit + PDP variant switch fire
  // unchanged. The menu frame lives at <body> level so fixed positioning is
  // reliable regardless of transformed ancestors.
  function enhanceSelect(select) {
    if (select.dataset.sa2SelectReady || !select.options.length) return;
    select.dataset.sa2SelectReady = '1';

    var block = select.getAttribute('data-sa2-select') === 'block';
    var lbl = select.id && document.querySelector('label[for="' + select.id + '"]');
    var title = select.getAttribute('data-sa2-select-title') || (lbl ? lbl.textContent.trim() : 'Select');

    var wrap = document.createElement('div');
    wrap.className = 'sa2-sel' + (block ? ' sa2-sel--block' : '');
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'sa2-sel__btn';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.innerHTML = '<span class="sa2-sel__val"></span>' +
      '<svg class="sa2-sel__car" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    wrap.appendChild(trigger);

    var frame = document.createElement('div');
    frame.className = 'sa2-selmenu';
    frame.innerHTML =
      '<div class="sa2-selmenu__scrim"></div>' +
      '<div class="sa2-selmenu__panel" role="listbox" tabindex="-1">' +
        '<div class="sa2-selmenu__head"><span class="sa2-selmenu__grip"></span><span class="sa2-selmenu__title"></span></div>' +
        '<ul class="sa2-selmenu__list"></ul>' +
      '</div>';
    var scrim = frame.querySelector('.sa2-selmenu__scrim');
    var panel = frame.querySelector('.sa2-selmenu__panel');
    var listEl = frame.querySelector('.sa2-selmenu__list');
    frame.querySelector('.sa2-selmenu__title').textContent = title;

    Array.prototype.forEach.call(select.options, function (opt, i) {
      var li = document.createElement('li');
      li.className = 'sa2-selmenu__opt';
      li.setAttribute('role', 'option');
      li.dataset.index = i;
      li.innerHTML = '<span class="sa2-selmenu__lbl"></span>' +
        '<svg class="sa2-selmenu__tick" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
      li.querySelector('.sa2-selmenu__lbl').textContent = opt.textContent;
      if (opt.disabled) li.setAttribute('aria-disabled', 'true');
      listEl.appendChild(li);
    });
    document.body.appendChild(frame);

    var valueEl = trigger.querySelector('.sa2-sel__val');
    var items = listEl.querySelectorAll('.sa2-selmenu__opt');
    var activeIndex = select.selectedIndex < 0 ? 0 : select.selectedIndex;
    var isOpen = false;

    function mobile() { return window.matchMedia('(max-width: 600px)').matches; }
    function syncLabel() { var o = select.options[select.selectedIndex]; valueEl.textContent = o ? o.textContent : ''; }
    function markSelected() {
      for (var i = 0; i < items.length; i++) {
        var s = i === select.selectedIndex;
        items[i].setAttribute('aria-selected', s ? 'true' : 'false');
        items[i].classList.toggle('is-sel', s);
      }
    }
    function setActive(i) {
      if (i < 0) i = 0; if (i > items.length - 1) i = items.length - 1;
      activeIndex = i;
      for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-act', k === i);
      if (items[i]) items[i].scrollIntoView({ block: 'nearest' });
    }
    function placeDesktop() {
      var r = trigger.getBoundingClientRect();
      panel.style.position = 'fixed';
      panel.style.bottom = 'auto'; panel.style.right = 'auto';
      var ph = Math.min(panel.scrollHeight || 320, 340);
      if (window.innerHeight - r.bottom < ph + 16 && r.top > ph + 16) panel.style.top = (r.top - ph - 8) + 'px';
      else panel.style.top = (r.bottom + 8) + 'px';
      if (block) { panel.style.left = r.left + 'px'; panel.style.minWidth = r.width + 'px'; }
      else { panel.style.minWidth = Math.max(r.width, 190) + 'px'; panel.style.left = Math.max(12, r.right - Math.max(r.width, 190)) + 'px'; }
    }
    function onDoc(e) { if (!panel.contains(e.target) && !trigger.contains(e.target)) closeMenu(); }
    function onWin() { if (!isOpen) return; if (mobile()) closeMenu(); else placeDesktop(); }
    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); }
      else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
      else if (e.key === 'End') { e.preventDefault(); setActive(items.length - 1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(activeIndex); }
      else if (e.key === 'Escape') { e.preventDefault(); closeMenu(); trigger.focus(); }
    }
    function openMenu() {
      isOpen = true;
      var m = mobile();
      frame.classList.toggle('is-sheet', m);
      if (!m) placeDesktop(); else { panel.style.position = ''; panel.style.top = ''; panel.style.left = ''; panel.style.minWidth = ''; }
      frame.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      if (m) document.body.style.overflow = 'hidden';
      setActive(select.selectedIndex < 0 ? 0 : select.selectedIndex);
      document.addEventListener('keydown', onKey, true);
      window.addEventListener('resize', onWin, true);
      window.addEventListener('scroll', onWin, true);
      setTimeout(function () { document.addEventListener('click', onDoc, true); }, 0);
    }
    function closeMenu() {
      isOpen = false;
      frame.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('click', onDoc, true);
      window.removeEventListener('resize', onWin, true);
      window.removeEventListener('scroll', onWin, true);
    }
    function choose(i) {
      var o = select.options[i]; if (!o || o.disabled) return;
      if (select.selectedIndex !== i) { select.selectedIndex = i; select.dispatchEvent(new Event('change', { bubbles: true })); }
      syncLabel(); markSelected(); closeMenu(); trigger.focus();
    }

    trigger.addEventListener('click', function () { isOpen ? closeMenu() : openMenu(); });
    trigger.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') && !isOpen) { e.preventDefault(); openMenu(); }
    });
    scrim.addEventListener('click', closeMenu);
    listEl.addEventListener('click', function (e) { var li = e.target.closest('.sa2-selmenu__opt'); if (li) choose(parseInt(li.dataset.index, 10)); });
    select.addEventListener('change', function () { syncLabel(); markSelected(); });

    syncLabel(); markSelected();
  }

  document.querySelectorAll('select[data-sa2-select]').forEach(enhanceSelect);
  // JudgeMe injects its review-sort <select> asynchronously — enhance on arrival
  var jmTries = 0;
  var jmTimer = setInterval(function () {
    var jm = document.querySelector('.jdgm-sort-dropdown');
    if (jm) { jm.setAttribute('data-sa2-select', 'block'); enhanceSelect(jm); clearInterval(jmTimer); }
    if (++jmTries > 20) clearInterval(jmTimer);
  }, 500);

})();
